import { SvgIcon } from "@mui/material"

export const CalendarIcon = (props) => (
  <svg
    style={props.style}
    width={!props.width ? "17" : props.width}
    height={!props.height ? "17" : props.height}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.4406 2.34591L11.4412 2.84566C13.2777 2.98959 14.4908 4.24096 14.4927 6.16L14.5 11.7772C14.5026 13.8695 13.1882 15.1568 11.0812 15.1602L5.93459 15.1668C3.8408 15.1695 2.50988 13.8515 2.50724 11.7532L2.5 6.20198C2.49737 4.27028 3.66768 3.02224 5.50411 2.85365L5.50346 2.3539C5.5028 2.06072 5.72001 1.84016 6.00963 1.84016C6.29924 1.83949 6.51645 2.05938 6.51711 2.35257L6.51777 2.819L10.4276 2.81367L10.4269 2.34724C10.4263 2.05405 10.6435 1.83416 10.9331 1.8335C11.2161 1.83283 11.4399 2.05272 11.4406 2.34591ZM3.51431 6.40787L13.4797 6.39455V6.16133C13.4514 4.72872 12.7327 3.97709 11.4426 3.86515L11.4432 4.37822C11.4432 4.66475 11.2201 4.89197 10.937 4.89197C10.6474 4.89263 10.4296 4.66608 10.4296 4.37956L10.4289 3.83983L6.51908 3.84516L6.51974 4.38422C6.51974 4.67141 6.30318 4.89796 6.01357 4.89796C5.72395 4.89863 5.50608 4.67274 5.50608 4.38555L5.50542 3.87248C4.2219 4.00108 3.51168 4.75537 3.51365 6.20064L3.51431 6.40787ZM10.66 9.43636V9.44369C10.6666 9.7502 10.9167 9.98275 11.2201 9.97609C11.5163 9.96876 11.7526 9.71488 11.7461 9.40837C11.7322 9.11518 11.4946 8.87597 11.1991 8.87664C10.8963 8.8833 10.6593 9.12984 10.66 9.43636ZM11.2036 12.4282C10.9008 12.4215 10.6566 12.169 10.656 11.8625C10.6494 11.556 10.8923 11.3021 11.195 11.2948H11.2016C11.511 11.2948 11.7618 11.5473 11.7618 11.8605C11.7624 12.1737 11.5123 12.4275 11.2036 12.4282ZM7.948 9.44702C7.96116 9.75353 8.21194 9.99275 8.51472 9.97942C8.81092 9.96543 9.04722 9.71222 9.03406 9.40571C9.02682 9.10586 8.78328 8.87264 8.48708 8.87331C8.1843 8.88663 7.94734 9.14051 7.948 9.44702ZM8.51737 12.3982C8.21459 12.4115 7.96447 12.1723 7.95065 11.8658C7.95065 11.5593 8.18695 11.3061 8.48973 11.2921C8.78593 11.2914 9.03013 11.5246 9.03671 11.8238C9.05053 12.131 8.81357 12.3842 8.51737 12.3982ZM5.23616 9.47034C5.24933 9.77685 5.50011 10.0167 5.80289 10.0027C6.09909 9.98941 6.33539 9.73554 6.32157 9.42903C6.31498 9.12918 6.07144 8.89596 5.77459 8.89663C5.47181 8.90995 5.23551 9.16383 5.23616 9.47034ZM5.80554 12.4015C5.50276 12.4155 5.25263 12.1756 5.23881 11.8691C5.23815 11.5626 5.47511 11.3087 5.77789 11.2954C6.07409 11.2948 6.31829 11.528 6.32487 11.8278C6.33869 12.1343 6.10239 12.3882 5.80554 12.4015Z"
      fill={props.color ? props.color : "black"}
    />
  </svg>
)
export const CallIcon = (props) => {
  return (
    <SvgIcon
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M16.1666 12.3797C15.4949 12.2352 14.9635 12.5471 14.493 12.8194C14.0111 13.1001 13.0949 13.8434 12.5697 13.6531C9.88084 12.546 7.35189 10.1925 6.25714 7.49286C6.0642 6.95647 6.804 6.0344 7.08259 5.54686C7.35292 5.07492 7.65833 4.53852 7.51904 3.86178C7.39316 3.25366 5.76497 1.18188 5.18923 0.615332C4.80952 0.241101 4.42053 0.0352739 4.02123 0.00200893C2.51995 -0.0624419 0.843272 1.94073 0.549208 2.41996C-0.187499 3.44181 -0.183372 4.80152 0.56159 6.45021C2.35693 10.8786 9.14723 17.5618 13.5922 19.4246C14.4125 19.8082 15.1626 20.0005 15.8364 20.0005C16.4957 20.0005 17.0828 19.8165 17.5874 19.4516C17.9681 19.2323 20.0534 17.4724 19.9987 15.9307C19.9657 15.5378 19.7604 15.1448 19.391 14.7644C18.8286 14.1833 16.7702 12.5065 16.1666 12.3797Z" />
    </SvgIcon>
  )
}

export const DocumentIcon = (props) => (
  <svg
    style={props.style}
    width={!props.width ? "24" : props.width}
    height={!props.height ? "28" : props.height}
    viewBox={"0 0 " + 24 + " " + 28}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.41333 0.666504H17.588C21.7067 0.666504 24 3.03984 24 7.1065V20.8798C24 25.0132 21.7067 27.3332 17.588 27.3332H6.41333C2.36 27.3332 0 25.0132 0 20.8798V7.1065C0 3.03984 2.36 0.666504 6.41333 0.666504ZM6.7734 6.87971V6.86637H10.7587C11.3334 6.86637 11.8001 7.33304 11.8001 7.90504C11.8001 8.49304 11.3334 8.95971 10.7587 8.95971H6.7734C6.19873 8.95971 5.7334 8.49304 5.7334 7.91971C5.7334 7.34637 6.19873 6.87971 6.7734 6.87971ZM6.7734 14.9861H17.2267C17.8001 14.9861 18.2667 14.5195 18.2667 13.9461C18.2667 13.3728 17.8001 12.9048 17.2267 12.9048H6.7734C6.19873 12.9048 5.7334 13.3728 5.7334 13.9461C5.7334 14.5195 6.19873 14.9861 6.7734 14.9861ZM6.77328 21.0796H17.2266C17.7586 21.0263 18.1599 20.5716 18.1599 20.0396C18.1599 19.493 17.7586 19.0396 17.2266 18.9863H6.77328C6.37328 18.9463 5.98662 19.133 5.77328 19.4796C5.55995 19.813 5.55995 20.253 5.77328 20.5996C5.98662 20.933 6.37328 21.133 6.77328 21.0796Z"
      fill={props.color ? props.color : "#fff"}
    />
  </svg>
)
export const PersonIcon = (props) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox={"0 0 " + 22 + " " + 28}
      fill="none"
      {...props}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.0585 7.72124C18.0585 11.6373 14.9187 14.7773 10.9999 14.7773C7.08242 14.7773 3.94124 11.6373 3.94124 7.72124C3.94124 3.8052 7.08242 0.666504 10.9999 0.666504C14.9187 0.666504 18.0585 3.8052 18.0585 7.72124ZM10.9999 27.3332C5.21642 27.3332 0.333252 26.3932 0.333252 22.7665C0.333252 19.1384 5.24709 18.2317 10.9999 18.2317C16.7848 18.2317 21.6666 19.1718 21.6666 22.7985C21.6666 26.4265 16.7527 27.3332 10.9999 27.3332Z"
      />
    </SvgIcon>
  )
}

export const ProfileIcon = (props) => (
  <svg
    style={props.style}
    width={!props.width ? "22" : props.width}
    height={!props.height ? "28" : props.height}
    viewBox={"0 0 " + 22 + " " + 28}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.0585 7.72124C18.0585 11.6373 14.9187 14.7773 10.9999 14.7773C7.08242 14.7773 3.94124 11.6373 3.94124 7.72124C3.94124 3.8052 7.08242 0.666504 10.9999 0.666504C14.9187 0.666504 18.0585 3.8052 18.0585 7.72124ZM10.9999 27.3332C5.21642 27.3332 0.333252 26.3932 0.333252 22.7665C0.333252 19.1384 5.24709 18.2317 10.9999 18.2317C16.7848 18.2317 21.6666 19.1718 21.6666 22.7985C21.6666 26.4265 16.7527 27.3332 10.9999 27.3332Z"
      fill={props.color ? props.color : "#fff"}
    />
  </svg>
)

export const HomeIcon = (props) => (
  <svg
    style={props.style}
    width={!props.width ? "20" : props.width}
    height={!props.height ? "20" : props.height}
    viewBox={"0 0 " + props.width + " " + props.height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.13478 18.7733V15.7156C7.13478 14.9351 7.77217 14.3023 8.55844 14.3023H11.4326C11.8102 14.3023 12.1723 14.4512 12.4393 14.7163C12.7063 14.9813 12.8563 15.3408 12.8563 15.7156V18.7733C12.8539 19.0978 12.9821 19.4099 13.2124 19.6402C13.4427 19.8705 13.7561 20 14.0829 20H16.0438C16.9596 20.0023 17.8388 19.6428 18.4872 19.0008C19.1356 18.3588 19.5 17.487 19.5 16.5778V7.86686C19.5 7.13246 19.1721 6.43584 18.6046 5.96467L11.934 0.675869C10.7737 -0.251438 9.11111 -0.221498 7.98539 0.746979L1.46701 5.96467C0.872741 6.42195 0.517552 7.12064 0.5 7.86686V16.5689C0.5 18.4639 2.04738 20 3.95617 20H5.87229C6.55123 20 7.103 19.4562 7.10792 18.7822L7.13478 18.7733Z"
      fill={props.color ? props.color : "#1D1D1D"}
    />
  </svg>
)

export const PlusIcon = (props) => (
  <svg
    style={props.style}
    width={!props.width ? "38" : props.width}
    height={!props.height ? "38" : props.height}
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 3V35"
      stroke={props.color ? props.color : "#449A68"}
      stroke-width="6"
      stroke-linecap="round"
    />
    <path
      d="M3 19H35"
      stroke={props.color ? props.color : "#449A68"}
      stroke-width="6"
      stroke-linecap="round"
    />
  </svg>
)

export const MoreSquareIcon = (props) => (
  <svg
    style={props.style}
    width={!props.width ? '21' : props.width}
    height={!props.height ? '20' : props.height}
    viewBox='0 0 21 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M6.17024 0H14.8402C18.2302 0 20.5002 2.38 20.5002 5.92V14.09C20.5002 17.62 18.2302 20 14.8402 20H6.17024C2.78024 20 0.500244 17.62 0.500244 14.09V5.92C0.500244 2.38 2.78024 0 6.17024 0ZM6.02024 11.2C5.36024 11.2 4.82024 10.66 4.82024 10C4.82024 9.34 5.36024 8.801 6.02024 8.801C6.68024 8.801 7.22024 9.34 7.22024 10C7.22024 10.66 6.68024 11.2 6.02024 11.2ZM9.30024 10C9.30024 10.66 9.84024 11.2 10.5002 11.2C11.1602 11.2 11.7002 10.66 11.7002 10C11.7002 9.34 11.1602 8.801 10.5002 8.801C9.84024 8.801 9.30024 9.34 9.30024 10ZM13.7802 10C13.7802 10.66 14.3202 11.2 14.9802 11.2C15.6402 11.2 16.1702 10.66 16.1702 10C16.1702 9.34 15.6402 8.801 14.9802 8.801C14.3202 8.801 13.7802 9.34 13.7802 10Z'
      fill={props.color ? props.color : '#449A68'}
    />
  </svg>
);

export const EditIcon = (props) => (
  <svg
    style={props.style}
    width={!props.width ? '18' : props.width}
    height={!props.height ? '18' : props.height}
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M6.3764 17.0279L15.1628 5.66544C15.6403 5.0527 15.8101 4.3443 15.6509 3.62299C15.513 2.96726 15.1097 2.34377 14.5049 1.87078L13.0299 0.699064C11.7459 -0.322161 10.1541 -0.214663 9.24152 0.957057L8.25465 2.23735C8.12731 2.39752 8.15914 2.63401 8.31832 2.76301C8.31832 2.76301 10.812 4.76246 10.8651 4.80546C11.0349 4.96671 11.1622 5.1817 11.1941 5.43969C11.2471 5.94493 10.8969 6.41792 10.377 6.48242C10.1329 6.51467 9.89944 6.43942 9.72966 6.29967L7.1086 4.21422C6.98126 4.11855 6.79025 4.13898 6.68413 4.26797L0.455138 12.3303C0.0518984 12.8355 -0.086052 13.4912 0.0518984 14.1255L0.847767 17.5761C0.890213 17.7589 1.04939 17.8879 1.24039 17.8879L4.74222 17.8449C5.37891 17.8341 5.97316 17.5439 6.3764 17.0279ZM11.2797 15.9533H16.9898C17.5469 15.9533 18 16.4123 18 16.9766C18 17.5421 17.5469 18 16.9898 18H11.2797C10.7226 18 10.2695 17.5421 10.2695 16.9766C10.2695 16.4123 10.7226 15.9533 11.2797 15.9533Z'
      fill={props.color ? props.color : '#449A68'}
    />
  </svg>
);

export const ShowIcon = (props) => (
  <svg
    style={props.style}
    width={!props.width ? '20' : props.width}
    height={!props.height ? '16' : props.height}
    viewBox='0 0 20 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M6.09756 8C6.09756 10.1333 7.8439 11.8691 10 11.8691C12.1463 11.8691 13.8927 10.1333 13.8927 8C13.8927 5.85697 12.1463 4.12121 10 4.12121C7.8439 4.12121 6.09756 5.85697 6.09756 8ZM15.7366 2.04606C17.4439 3.36485 18.8976 5.29455 19.9415 7.70909C20.0195 7.89333 20.0195 8.10667 19.9415 8.28121C17.8537 13.1103 14.1366 16 10 16H9.99024C5.86341 16 2.14634 13.1103 0.0585366 8.28121C-0.0195122 8.10667 -0.0195122 7.89333 0.0585366 7.70909C2.14634 2.88 5.86341 0 9.99024 0H10C12.0683 0 14.0293 0.717576 15.7366 2.04606ZM10.0012 10.4124C11.3378 10.4124 12.4304 9.32635 12.4304 7.99787C12.4304 6.65968 11.3378 5.57362 10.0012 5.57362C9.8841 5.57362 9.76702 5.58332 9.65971 5.60272C9.62068 6.66938 8.74263 7.52272 7.65971 7.52272H7.61093C7.58166 7.67787 7.56215 7.83302 7.56215 7.99787C7.56215 9.32635 8.65483 10.4124 10.0012 10.4124Z'
      fill={props.color ? props.color : '#449A68'}
    />
  </svg>
);

export const ToggleIcon = (props) => (
  <svg
    style={props.style}
    width={!props.width ? '24' : props.width}
    height={!props.height ? '15' : props.height}
    viewBox='0 0 24 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect x='0.428571' y='1.07164' width='23.1429' height='12.8571' rx='6.42857' fill='white' stroke='#449A68' stroke-width='0.857143' />
    <circle cx='17.1429' cy='7.50028' r='5.14286' fill={props.color ? props.color : '#449A68'} />
  </svg>
);

export const SendIcon = (props) => (
  <svg
    style={props.style}
    width={!props.width ? '20' : props.width}
    height={!props.height ? '20' : props.height}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M19.4354 0.581983C18.9352 0.0685981 18.1949 -0.122663 17.5046 0.0786645L1.408 4.75952C0.679698 4.96186 0.163487 5.54269 0.0244302 6.28055C-0.117628 7.0315 0.378575 7.98479 1.02684 8.38342L6.0599 11.4768C6.57611 11.7939 7.24238 11.7144 7.66956 11.2835L13.4329 5.4843C13.723 5.18231 14.2032 5.18231 14.4934 5.4843C14.7835 5.77623 14.7835 6.24935 14.4934 6.55134L8.71999 12.3516C8.29181 12.7814 8.21178 13.4508 8.52691 13.9702L11.6022 19.0538C11.9623 19.6577 12.5826 20 13.2628 20C13.3429 20 13.4329 20 13.513 19.9899C14.2933 19.8893 14.9135 19.3558 15.1436 18.6008L19.9156 2.52479C20.1257 1.84028 19.9356 1.09537 19.4354 0.581983Z'
      fill={props.color ? props.color : '#449A68'}
    />
  </svg>
);

export const PaperPlusIcon = (props) => (
  <svg
    style={props.style}
    width={!props.width ? '18' : props.width}
    height={!props.height ? '20' : props.height}
    viewBox='0 0 18 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M9.54951 11.73H11.2624C11.6683 11.73 12.005 11.4 12.005 10.99C12.005 10.57 11.6683 10.24 11.2624 10.24H9.54951V8.51C9.54951 8.1 9.22277 7.77 8.81683 7.77C8.41089 7.77 8.07426 8.1 8.07426 8.51V10.24H6.37129C5.96535 10.24 5.62871 10.57 5.62871 10.99C5.62871 11.4 5.96535 11.73 6.37129 11.73H8.07426V13.46C8.07426 13.87 8.41089 14.2 8.81683 14.2C9.22277 14.2 9.54951 13.87 9.54951 13.46V11.73ZM16.3381 7.02561C16.5708 7.02292 16.8242 7.02 17.0545 7.02C17.302 7.02 17.5 7.22 17.5 7.47V15.51C17.5 17.99 15.5099 20 13.0446 20H5.17327C2.59901 20 0.5 17.89 0.5 15.29V4.51C0.5 2.03 2.5 0 4.96535 0H10.2525C10.5099 0 10.7079 0.21 10.7079 0.46V3.68C10.7079 5.51 12.203 7.01 14.0149 7.02C14.4381 7.02 14.8112 7.02316 15.1377 7.02593C15.3917 7.02809 15.6175 7.03 15.8168 7.03C15.9578 7.03 16.1405 7.02789 16.3381 7.02561ZM16.61 5.5662C15.7961 5.5692 14.8367 5.5662 14.1466 5.5592C13.0516 5.5592 12.1496 4.6482 12.1496 3.5422V0.9062C12.1496 0.4752 12.6674 0.2612 12.9635 0.5722C13.4995 1.1351 14.2361 1.90891 14.9693 2.67913C15.7002 3.44689 16.4277 4.21108 16.9496 4.7592C17.2387 5.0622 17.0268 5.5652 16.61 5.5662Z'
      fill={props.color ? props.color : '#449A68'}
    />
  </svg>
);

export const PaperIcon = (props) => (
  <svg
    style={props.style}
    width={!props.width ? '18' : props.width}
    height={!props.height ? '20' : props.height}
    viewBox='0 0 18 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M5.92574 14.39H11.3119C11.7178 14.39 12.0545 14.05 12.0545 13.64C12.0545 13.23 11.7178 12.9 11.3119 12.9H5.92574C5.5198 12.9 5.18317 13.23 5.18317 13.64C5.18317 14.05 5.5198 14.39 5.92574 14.39ZM9.27228 7.9H5.92574C5.5198 7.9 5.18317 8.24 5.18317 8.65C5.18317 9.06 5.5198 9.39 5.92574 9.39H9.27228C9.67822 9.39 10.0149 9.06 10.0149 8.65C10.0149 8.24 9.67822 7.9 9.27228 7.9ZM16.3381 7.02561C16.5708 7.02292 16.8242 7.02 17.0545 7.02C17.302 7.02 17.5 7.22 17.5 7.47V15.51C17.5 17.99 15.5099 20 13.0545 20H5.17327C2.59901 20 0.5 17.89 0.5 15.29V4.51C0.5 2.03 2.5 0 4.96535 0H10.2525C10.5099 0 10.7079 0.21 10.7079 0.46V3.68C10.7079 5.51 12.203 7.01 14.0149 7.02C14.4381 7.02 14.8112 7.02316 15.1377 7.02593C15.3917 7.02809 15.6175 7.03 15.8168 7.03C15.9578 7.03 16.1405 7.02789 16.3381 7.02561ZM16.6111 5.566C15.7972 5.569 14.8378 5.566 14.1477 5.559C13.0527 5.559 12.1507 4.648 12.1507 3.542V0.906C12.1507 0.475 12.6685 0.261 12.9646 0.572C13.5004 1.13476 14.2368 1.90834 14.9699 2.67837C15.7009 3.44632 16.4286 4.21074 16.9507 4.759C17.2398 5.062 17.0279 5.565 16.6111 5.566Z'
      fill={props.color ? props.color : '#449A68'}
    />
  </svg>
);

export const ChartIcon = (props) => (
  <svg
    style={props.style}
    width={!props.width ? "28" : props.width}
    height={!props.height ? "28" : props.height}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill={props.color ? props.color : "#449A68"}
      d="M7.77366 0.666992H20.2257C24.7603 0.666992 27.3203 3.23899 27.3337 7.77366V20.227C27.3337 24.7603 24.7603 27.3337 20.2257 27.3337H7.77366C3.23899 27.3337 0.666992 24.7603 0.666992 20.227V7.77366C0.666992 3.23899 3.23899 0.666992 7.77366 0.666992ZM14.0656 21.8136C14.6403 21.8136 15.119 21.387 15.1723 20.8136V7.22697C15.2256 6.81364 15.027 6.39897 14.667 6.17364C14.2923 5.94697 13.839 5.94697 13.4803 6.17364C13.119 6.39897 12.9203 6.81364 12.959 7.22697V20.8136C13.027 21.387 13.5056 21.8136 14.0656 21.8136ZM20.2003 21.8137C20.7603 21.8137 21.239 21.387 21.307 20.8137V16.4403C21.3456 16.0123 21.147 15.6137 20.7856 15.387C20.427 15.1603 19.9736 15.1603 19.6003 15.387C19.239 15.6137 19.0403 16.0123 19.0936 16.4403V20.8137C19.147 21.387 19.6256 21.8137 20.2003 21.8137ZM8.95898 20.8137C8.90565 21.387 8.42698 21.8137 7.85231 21.8137C7.27898 21.8137 6.79898 21.387 6.74698 20.8137V11.6003C6.70698 11.1856 6.90564 10.7736 7.26698 10.547C7.62564 10.3203 8.08031 10.3203 8.44031 10.547C8.79898 10.7736 9.00031 11.1856 8.95898 11.6003V20.8137Z"
    />
  </svg>
)

export const ChartMatIcon = (props) => (
  <SvgIcon
    {...props}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.77366 0.666992H20.2257C24.7603 0.666992 27.3203 3.23899 27.3337 7.77366V20.227C27.3337 24.7603 24.7603 27.3337 20.2257 27.3337H7.77366C3.23899 27.3337 0.666992 24.7603 0.666992 20.227V7.77366C0.666992 3.23899 3.23899 0.666992 7.77366 0.666992ZM14.0656 21.8136C14.6403 21.8136 15.119 21.387 15.1723 20.8136V7.22697C15.2256 6.81364 15.027 6.39897 14.667 6.17364C14.2923 5.94697 13.839 5.94697 13.4803 6.17364C13.119 6.39897 12.9203 6.81364 12.959 7.22697V20.8136C13.027 21.387 13.5056 21.8136 14.0656 21.8136ZM20.2003 21.8137C20.7603 21.8137 21.239 21.387 21.307 20.8137V16.4403C21.3456 16.0123 21.147 15.6137 20.7856 15.387C20.427 15.1603 19.9736 15.1603 19.6003 15.387C19.239 15.6137 19.0403 16.0123 19.0936 16.4403V20.8137C19.147 21.387 19.6256 21.8137 20.2003 21.8137ZM8.95898 20.8137C8.90565 21.387 8.42698 21.8137 7.85231 21.8137C7.27898 21.8137 6.79898 21.387 6.74698 20.8137V11.6003C6.70698 11.1856 6.90564 10.7736 7.26698 10.547C7.62564 10.3203 8.08031 10.3203 8.44031 10.547C8.79898 10.7736 9.00031 11.1856 8.95898 11.6003V20.8137Z"
    />
  </SvgIcon>
)

export const DownloadIcon = (props) => (
  <svg
    style={props.style}
    width={!props.width ? "28" : props.width}
    height={!props.height ? "26" : props.height}
    viewBox="0 0 28 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.9733 6.72086V1.3755C12.9733 0.807135 13.4266 0.333496 14 0.333496C14.5133 0.333496 14.9482 0.731485 15.0171 1.2356L15.0266 1.3755V6.72086L21.3998 6.72126C24.5732 6.72126 27.1803 9.31987 27.3267 12.5607L27.3332 12.8483V19.5673C27.3332 22.8309 24.8167 25.5098 21.6905 25.6602L21.4132 25.6668H6.5865C3.41317 25.6668 0.818624 23.0812 0.672954 19.8285L0.666504 19.5398L0.666504 12.8345C0.666504 9.57097 3.17038 6.87911 6.29583 6.72796L6.57317 6.72126H12.9732V15.2578L10.8398 13.0548C10.4398 12.6418 9.7865 12.6418 9.3865 13.0548C9.1865 13.2613 9.09317 13.5367 9.09317 13.8121C9.09317 14.0214 9.1529 14.2395 9.2792 14.4241L9.3865 14.5556L13.2665 18.576C13.4532 18.7825 13.7198 18.8927 13.9998 18.8927C14.2221 18.8927 14.4443 18.8162 14.6202 18.6712L14.7198 18.576L18.5998 14.5556C18.9998 14.1425 18.9998 13.4679 18.5998 13.0548C18.2362 12.6793 17.6632 12.6452 17.2615 12.9524L17.1465 13.0548L15.0265 15.2578V6.72126L12.9733 6.72086Z"
      fill={props.color ? props.color : "#449A68"}
    />
  </svg>
)

export const DeleteIcon = (props) => (
  <svg
    style={props.style}
    width={!props.width ? "18" : props.width}
    height={!props.height ? "20" : props.height}
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill={props.color ? props.color : "#449A68"}
      d="M17.2871 3.24297C17.6761 3.24297 18 3.56596 18 3.97696V4.35696C18 4.75795 17.6761 5.09095 17.2871 5.09095H0.713853C0.32386 5.09095 0 4.75795 0 4.35696V3.97696C0 3.56596 0.32386 3.24297 0.713853 3.24297H3.62957C4.22185 3.24297 4.7373 2.82197 4.87054 2.22798L5.02323 1.54598C5.26054 0.616994 6.0415 0 6.93527 0H11.0647C11.9488 0 12.7385 0.616994 12.967 1.49699L13.1304 2.22698C13.2627 2.82197 13.7781 3.24297 14.3714 3.24297H17.2871ZM15.8058 17.134C16.1102 14.2971 16.6432 7.55712 16.6432 7.48913C16.6626 7.28313 16.5955 7.08813 16.4623 6.93113C16.3193 6.78413 16.1384 6.69713 15.9391 6.69713H2.06852C1.86818 6.69713 1.67756 6.78413 1.54529 6.93113C1.41108 7.08813 1.34494 7.28313 1.35467 7.48913C1.35646 7.50162 1.37558 7.73903 1.40755 8.13594C1.54958 9.89917 1.94517 14.8102 2.20079 17.134C2.38168 18.846 3.50498 19.922 5.13206 19.961C6.38763 19.99 7.68112 20 9.00379 20C10.2496 20 11.5149 19.99 12.8094 19.961C14.4929 19.932 15.6152 18.875 15.8058 17.134Z"
    />
  </svg>
)

export const PlusFilledIcon = (props) => (
  <svg
    style={props.style}
    width={!props.width ? "21" : props.width}
    height={!props.height ? "20" : props.height}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill={props.color ? props.color : "#449A68"}
      d="M5.83 0H15.16C18.56 0 20.5 1.92 20.5 5.33V14.67C20.5 18.06 18.57 20 15.17 20H5.83C2.42 20 0.5 18.06 0.5 14.67V5.33C0.5 1.92 2.42 0 5.83 0ZM11.32 10.83H14.16C14.62 10.82 14.99 10.45 14.99 9.99C14.99 9.53 14.62 9.16 14.16 9.16H11.32V6.34C11.32 5.88 10.95 5.51 10.49 5.51C10.03 5.51 9.66 5.88 9.66 6.34V9.16H6.83C6.61 9.16 6.4 9.25 6.24 9.4C6.09 9.56 6 9.769 6 9.99C6 10.45 6.37 10.82 6.83 10.83H9.66V13.66C9.66 14.12 10.03 14.49 10.49 14.49C10.95 14.49 11.32 14.12 11.32 13.66V10.83Z"
    />
  </svg>
)

export const TitleDescIcon = (props) => (
  <svg
    style={props.style}
    width={!props.width ? "19" : props.width}
    height={!props.height ? "16" : props.height}
    viewBox="0 0 19 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.5004 0H0.5V4.00013H12.5004V0ZM4.49964 4.00015L4.49964 16.0005H8.49976L8.49976 4.00015H4.49964Z"
      fill={props.color ? props.color : "#449A68"}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.5002 8.00049H12.5V10.0006H18.5002V8.00049ZM14.5003 10.0006L14.5003 16.0008H16.5004V10.0006H14.5003Z"
      fill={props.color ? props.color : "#449A68"}
    />
  </svg>
)

export const ImageIcon = (props) => (
  <svg
    style={props.style}
    width={!props.width ? "21" : props.width}
    height={!props.height ? "20" : props.height}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.16618 20H14.8328C18.2231 20 20.5 17.6219 20.5 14.0833V5.91672C20.5 2.37811 18.2231 0 14.8338 0H6.16618C2.7769 0 0.5 2.37811 0.5 5.91672V14.0833C0.5 17.6219 2.7769 20 6.16618 20ZM6.99886 9C5.62021 9 4.5 7.87827 4.5 6.5C4.5 5.12173 5.62021 4 6.99886 4C8.3765 4 9.49772 5.12173 9.49772 6.5C9.49772 7.87827 8.3765 9 6.99886 9ZM18.3208 12.934C18.6557 13.7926 18.4817 14.8246 18.1237 15.6749C17.6994 16.6863 16.8869 17.452 15.8632 17.7864C15.4087 17.935 14.932 18 14.4564 18H6.02864C5.18999 18 4.44788 17.7988 3.8395 17.4241C3.45839 17.1889 3.39102 16.646 3.67358 16.2941C4.1462 15.7059 4.61279 15.1156 5.0834 14.5201C5.98038 13.3808 6.58473 13.0506 7.25645 13.3406C7.52896 13.4603 7.80248 13.6398 8.08404 13.8297C8.8342 14.3395 9.87699 15.0402 11.2506 14.2797C12.1906 13.7532 12.7358 12.8501 13.2106 12.0637L13.2185 12.0506C13.2522 11.9954 13.2855 11.9402 13.3187 11.8852C13.4783 11.6212 13.6357 11.3607 13.8138 11.1207C14.0371 10.8204 14.8646 9.88132 15.9366 10.5501C16.6194 10.9711 17.1936 11.5408 17.808 12.1507C18.0423 12.3839 18.2092 12.6491 18.3208 12.934Z"
      fill={props.color ? props.color : "#449A68"}
    />
  </svg>
)

export const PlayIcon = (props) => (
  <svg
    style={props.style}
    width={!props.width ? "21" : props.width}
    height={!props.height ? "20" : props.height}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.5 10.0058C0.5 4.48625 4.98842 0 10.5 0C16.0116 0 20.5 4.48625 20.5 10.0058C20.5 15.5137 16.0116 20 10.5 20C4.98842 20 0.5 15.5137 0.5 10.0058ZM14.1684 11.0179C14.2746 10.9118 14.4097 10.7477 14.4387 10.7092C14.5931 10.5066 14.6704 10.2557 14.6704 10.0058C14.6704 9.72508 14.5835 9.46458 14.4194 9.25233C14.406 9.23889 14.3796 9.21023 14.3453 9.17288C14.2811 9.103 14.1889 9.00268 14.1009 8.91466C13.3094 8.06565 11.2437 6.67635 10.1626 6.25185C9.99855 6.18528 9.58349 6.0396 9.36149 6.02995C9.14913 6.02995 8.94643 6.07819 8.75338 6.17467C8.51207 6.30974 8.31902 6.52199 8.21284 6.77283C8.14527 6.94649 8.03909 7.46748 8.03909 7.47713C7.93292 8.04635 7.875 8.97254 7.875 9.99522C7.875 10.9706 7.93292 11.8573 8.01979 12.4361C8.02218 12.4385 8.03048 12.4799 8.04338 12.5442C8.08259 12.7398 8.16429 13.1471 8.25145 13.3141C8.4638 13.7193 8.87886 13.9701 9.32288 13.9701H9.36149C9.65106 13.9605 10.2592 13.7096 10.2592 13.7C11.2823 13.2755 13.2997 11.9537 14.1105 11.0758L14.1684 11.0179Z"
      fill={props.color ? props.color : "#449A68"}
    />
  </svg>
)

export const AddSectionIcon = (props) => (
  <svg
    style={props.style}
    width={!props.width ? "17" : props.width}
    height={!props.height ? "16" : props.height}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 1.6C0.5 0.716344 1.21634 0 2.1 0H14.9C15.7837 0 16.5 0.716344 16.5 1.6V4.8C16.5 5.68366 15.7837 6.4 14.9 6.4H2.1C1.21634 6.4 0.5 5.68366 0.5 4.8V1.6Z"
      fill={props.color ? props.color : "#449A68"}
    />
    <path
      d="M0.5 11.2C0.5 10.3163 1.21634 9.6 2.1 9.6H14.9C15.7837 9.6 16.5 10.3163 16.5 11.2V14.4C16.5 15.2837 15.7837 16 14.9 16H2.1C1.21634 16 0.5 15.2837 0.5 14.4V11.2Z"
      fill={props.color ? props.color : "#449A68"}
    />
  </svg>
)

export const ImageFilledIcon = (props) => (
  <svg
    style={props.style}
    width={!props.width ? "48" : props.width}
    height={!props.height ? "48" : props.height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0H40C44.4183 0 48 3.58172 48 8V40C48 44.4183 44.4183 48 40 48H8C3.58172 48 0 44.4183 0 40V8Z"
      fill={props.color ? props.color : "#449A68"}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.7662 13.674C15.6738 13.674 13.6758 15.7944 13.6758 19.0656V28.9224C13.6758 29.8404 13.8462 30.66 14.1378 31.3692C14.1504 31.3542 14.4249 31.0197 14.783 30.5832C15.4832 29.73 16.503 28.4872 16.5102 28.4808C17.3406 27.5328 18.8994 26.1192 20.9454 26.9748C21.3937 27.1607 21.7922 27.4154 22.1591 27.6498C22.1948 27.6726 22.2302 27.6953 22.2654 27.7176C22.953 28.1772 23.3574 28.3932 23.7774 28.3572C23.9514 28.3332 24.1146 28.2816 24.2694 28.1856C24.8533 27.8256 26.3673 25.6805 26.8206 25.0381C26.8871 24.9439 26.9308 24.882 26.9454 24.8628C28.2534 23.1588 30.2694 22.7028 31.9494 23.7108C32.175 23.8452 33.7914 24.9744 34.3266 25.428V19.0656C34.3266 15.7944 32.3286 13.674 29.2254 13.674H18.7662ZM29.2248 12C33.2772 12 36 14.8344 36 19.0656V28.9224C36 29.0288 35.9888 29.1286 35.9777 29.2284C35.9698 29.2984 35.962 29.3685 35.958 29.4408C35.9554 29.4845 35.9542 29.5282 35.9529 29.5719C35.9513 29.6302 35.9496 29.6885 35.9448 29.7468C35.9424 29.7696 35.9379 29.7915 35.9334 29.8134C35.9289 29.8353 35.9244 29.8572 35.922 29.88C35.8824 30.2568 35.8212 30.6168 35.736 30.966C35.7159 31.0533 35.6926 31.1374 35.6691 31.2223L35.664 31.2408C35.568 31.5792 35.4552 31.902 35.3196 32.2104C35.2958 32.2622 35.2708 32.3128 35.2457 32.3633C35.229 32.397 35.2123 32.4307 35.196 32.4648C35.0496 32.7588 34.8912 33.0408 34.7076 33.3024C34.6736 33.3508 34.6375 33.3962 34.6013 33.4417C34.5773 33.4717 34.5534 33.5018 34.53 33.5328C34.3392 33.78 34.14 34.0164 33.9144 34.2312C33.8694 34.274 33.8207 34.3132 33.772 34.3524C33.7416 34.3769 33.7111 34.4014 33.6816 34.4268C33.45 34.626 33.2136 34.8168 32.9532 34.98C32.8964 35.0157 32.836 35.0457 32.7758 35.0755C32.7369 35.0948 32.6981 35.1141 32.6604 35.1348C32.3952 35.2812 32.1276 35.424 31.836 35.5344C31.7658 35.5611 31.6912 35.5803 31.6163 35.5997C31.5631 35.6134 31.5098 35.6272 31.458 35.6436C31.432 35.6516 31.4061 35.6597 31.3802 35.6678C31.1197 35.7488 30.8601 35.8296 30.5796 35.8776C30.4171 35.9061 30.2447 35.917 30.0721 35.928C29.9974 35.9327 29.9227 35.9374 29.8488 35.9436C29.7693 35.9495 29.6914 35.9591 29.6134 35.9687C29.4865 35.9844 29.3593 36 29.2248 36H18.7656C18.3144 36 17.8836 35.9544 17.4672 35.886C17.4517 35.8836 17.4375 35.8812 17.4232 35.8789L17.4228 35.8788C15.7992 35.5992 14.4516 34.8156 13.5072 33.6336C13.5006 33.6336 13.4981 33.6292 13.4946 33.6233C13.4924 33.6195 13.4898 33.615 13.4856 33.6108C12.5364 32.4156 12 30.8088 12 28.9224V19.0656C12 14.8344 14.7252 12 18.7656 12H29.2248ZM22.8012 19.8174C22.8012 21.4433 21.4407 22.7994 19.807 22.7994C18.3709 22.7994 17.1465 21.7502 16.8721 20.3918C16.8268 20.188 16.8012 19.9783 16.8012 19.7618C16.8012 18.1243 18.1314 16.7994 19.7756 16.7994C20.6128 16.7994 21.3709 17.1515 21.914 17.7131C22.4593 18.2551 22.8012 19.0021 22.8012 19.8174Z"
      fill="white"
    />
  </svg>
)

export const CloseIcon = (props) => (
  <svg
    style={props.style}
    width={!props.width ? "33" : props.width}
    height={!props.height ? "32" : props.height}
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.6668 16.0002C29.6668 23.2719 23.7719 29.1668 16.5002 29.1668C9.22841 29.1668 3.3335 23.2719 3.3335 16.0002C3.3335 8.72841 9.22841 2.8335 16.5002 2.8335C23.7719 2.8335 29.6668 8.72841 29.6668 16.0002Z"
      stroke={props.color ? props.color : "#449A68"}
      stroke-width="3"
    />
    <path
      d="M19.9491 21.3081L16.7722 18.1312L13.6029 21.3005C13.0877 21.8156 12.2595 21.8161 11.7449 21.3015C11.2303 20.7869 11.2308 19.9587 11.7459 19.4435L14.9152 16.2742L11.7495 13.1085C11.2461 12.5827 11.2465 11.7544 11.7617 11.2393C12.0092 10.9918 12.3439 10.8584 12.6909 10.847C13.0379 10.858 13.3736 10.9921 13.6197 11.2382L16.7854 14.404L19.9435 11.2459C20.4587 10.7308 21.287 10.7303 21.8015 11.2449C22.3161 11.7595 22.3156 12.5877 21.8005 13.1029L18.6424 16.261L21.8194 19.4379C22.3339 19.9525 22.3335 20.7808 21.8183 21.2959C21.3032 21.8111 20.4749 21.8115 19.9491 21.3081Z"
      fill={props.color ? props.color : "#449A68"}
    />
  </svg>
)

export const AddQuestionIcon = (props) => (
  <svg
    style={props.style}
    width={!props.width ? "16" : props.width}
    height={!props.height ? "20" : props.height}
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill={props.color ? props.color : "#449A68"}
      d="M3.03982 14.7618V3.49196H2.2461C1.28338 3.49196 0.5 4.27534 0.5 5.23819V18.2539C0.5 19.2166 1.28338 20 2.2461 20H10.5C11.4626 20 12.246 19.2166 12.246 18.2539V17.4602H5.73819C4.25021 17.4602 3.03982 16.2498 3.03982 14.7618ZM15.7382 1.74598C15.7382 0.783379 14.9548 0 13.992 0H5.73819C4.77546 0 3.99208 0.783379 3.99208 1.74598V14.7618C3.99208 15.7245 4.77546 16.5079 5.73819 16.5079H13.992C14.9548 16.5079 15.7382 15.7245 15.7382 14.7618V1.74598Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.4277 8.5671H10.7593V10.3C10.7593 10.7106 10.4411 11.0412 10.0457 11.0412C9.65032 11.0412 9.32243 10.7106 9.32243 10.3V8.5671H7.66371C7.26832 8.5671 6.94043 8.23656 6.94043 7.82589C6.94043 7.40519 7.26832 7.07465 7.66371 7.07465H9.32243V5.3418C9.32243 4.93113 9.65032 4.60059 10.0457 4.60059C10.4411 4.60059 10.7593 4.93113 10.7593 5.3418V7.07465H12.4277C12.8231 7.07465 13.151 7.40519 13.151 7.82589C13.151 8.23656 12.8231 8.5671 12.4277 8.5671Z"
      fill="white"
    />
  </svg>
)

export const LinearScaleIcon = (props) => (
  <svg
    style={props.style}
    width={!props.width ? '25' : props.width}
    height={!props.height ? '24' : props.height}
    viewBox='0 0 25 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='5' cy='11.5' r='4.5' fill={props.color ? props.color : '#449A68'} />
    <circle cx='20' cy='11.5' r='3.5' stroke={props.color ? props.color : '#449A68'} stroke-width='2' />
    <rect x='8.5' y='10' width='9' height='3' fill={props.color ? props.color : '#449A68'} />
  </svg>
);

export const ArrowRightCircleIcon = (props) => (
  <svg
    style={props.style}
    width={!props.width ? "41" : props.width}
    height={!props.height ? "40" : props.height}
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill={props.color ? props.color : "#449A68"}
      d="M37.1668 20.0002C37.1668 29.2002 29.6835 36.6668 20.5002 36.6668L20.0339 36.6604C11.0492 36.4132 3.8335 29.0442 3.8335 20.0002C3.8335 10.8168 11.3002 3.3335 20.5002 3.3335C29.6835 3.3335 37.1668 10.8168 37.1668 20.0002ZM17.2002 13.3335C16.7168 13.8335 16.7168 14.6168 17.2168 15.1002L22.1335 20.0002L17.2168 24.9002C16.7168 25.3835 16.7168 26.1835 17.2002 26.6668C17.7002 27.1668 18.4835 27.1668 18.9668 26.6668L24.7835 20.8835C25.0168 20.6502 25.1502 20.3335 25.1502 20.0002C25.1502 19.6668 25.0168 19.3502 24.7835 19.1168L18.9668 13.3335C18.7335 13.0835 18.4168 12.9668 18.1002 12.9668C17.7668 12.9668 17.4502 13.0835 17.2002 13.3335Z"
    />
  </svg>
)

export const ArrowUpCircleIcon = (props) => (
  <svg
    style={props.style}
    width={!props.width ? "41" : props.width}
    height={!props.height ? "40" : props.height}
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.5002 3.83317C29.7002 3.83317 37.1668 11.3165 37.1668 20.4998L37.1604 20.9661C36.9132 29.9508 29.5442 37.1665 20.5002 37.1665C11.3168 37.1665 3.8335 29.6998 3.8335 20.4998C3.83349 11.3165 11.3168 3.83317 20.5002 3.83317ZM13.8335 23.7998C14.3335 24.2832 15.1168 24.2832 15.6002 23.7832L20.5002 18.8665L25.4002 23.7832C25.8835 24.2832 26.6835 24.2832 27.1668 23.7998C27.6668 23.2998 27.6668 22.5165 27.1668 22.0332L21.3835 16.2165C21.1502 15.9832 20.8335 15.8498 20.5002 15.8498C20.1668 15.8498 19.8502 15.9832 19.6168 16.2165L13.8335 22.0332C13.5835 22.2665 13.4668 22.5832 13.4668 22.8998C13.4668 23.2332 13.5835 23.5498 13.8335 23.7998Z"
      fill={props.color ? props.color : "#449A68"}
    />
  </svg>
)

export const FolderIcon = (props) => (
  <svg
    style={props.style}
    width={!props.width ? "20" : props.width}
    height={!props.height ? "20" : props.height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill={props.color ? props.color : "#200E32"}
      d="M11.45 2.88017H14.52C18.21 2.88017 20.01 4.85017 20 8.89017V13.7602C20 17.6202 17.62 20.0002 13.75 20.0002H6.24C2.39 20.0002 0 17.6202 0 13.7502V6.24017C0 2.10017 1.84 0.000170661 5.47 0.000170661H7.05C7.981 -0.00982934 8.85 0.420171 9.42 1.15017L10.3 2.32017C10.58 2.67017 11 2.88017 11.45 2.88017ZM5.37 13.2902H14.63C15.04 13.2902 15.37 12.9502 15.37 12.5402C15.37 12.1202 15.04 11.7902 14.63 11.7902H5.37C4.95 11.7902 4.62 12.1202 4.62 12.5402C4.62 12.9502 4.95 13.2902 5.37 13.2902Z"
    />
  </svg>
)

export const ClockIcon = (props) => (
  <svg
    style={props.style}
    width={!props.width ? '20' : props.width}
    height={!props.height ? '20' : props.height}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      fill={props.color ? props.color : '#449A68'}
      d='M5.67 0H14.34C17.73 0 20 2.379 20 5.919V14.089C20 17.62 17.73 20 14.34 20H5.67C2.28 20 0 17.62 0 14.089V5.919C0 2.379 2.28 0 5.67 0ZM13.58 13.81C13.83 13.81 14.08 13.68 14.22 13.44C14.44 13.089 14.32 12.629 13.96 12.41L10.4 10.29V5.669C10.4 5.26 10.07 4.919 9.65 4.919C9.24 4.919 8.9 5.26 8.9 5.669V10.72C8.9 10.98 9.04 11.23 9.27 11.36L13.19 13.7C13.31 13.78 13.45 13.81 13.58 13.81Z'
    />
  </svg>
);
export const EmailIcon = (props) => {
  return (
    <SvgIcon
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.9394 0C16.2804 0 17.5704 0.53 18.5194 1.481C19.4694 2.43 20.0004 3.71 20.0004 5.05V12.95C20.0004 15.74 17.7304 18 14.9394 18H5.0604C2.2694 18 0.000396729 15.74 0.000396729 12.95V5.05C0.000396729 2.26 2.2594 0 5.0604 0H14.9394ZM16.5304 6.54L16.6104 6.46C16.8494 6.17 16.8494 5.75 16.5994 5.46C16.4604 5.311 16.2694 5.22 16.0704 5.2C15.8604 5.189 15.6604 5.26 15.5094 5.4L11.0004 9C10.4204 9.481 9.5894 9.481 9.0004 9L4.5004 5.4C4.1894 5.17 3.7594 5.2 3.5004 5.47C3.2304 5.74 3.2004 6.17 3.4294 6.47L3.5604 6.6L8.1104 10.15C8.6704 10.59 9.3494 10.83 10.0604 10.83C10.7694 10.83 11.4604 10.59 12.0194 10.15L16.5304 6.54Z"
      />
    </SvgIcon>
  )
}

export const CalendarMatIcon = (props) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.4406 2.34591L11.4412 2.84566C13.2777 2.98959 14.4908 4.24096 14.4927 6.16L14.5 11.7772C14.5026 13.8695 13.1882 15.1568 11.0812 15.1602L5.93459 15.1668C3.8408 15.1695 2.50988 13.8515 2.50724 11.7532L2.5 6.20198C2.49737 4.27028 3.66768 3.02224 5.50411 2.85365L5.50346 2.3539C5.5028 2.06072 5.72001 1.84016 6.00963 1.84016C6.29924 1.83949 6.51645 2.05938 6.51711 2.35257L6.51777 2.819L10.4276 2.81367L10.4269 2.34724C10.4263 2.05405 10.6435 1.83416 10.9331 1.8335C11.2161 1.83283 11.4399 2.05272 11.4406 2.34591ZM3.51431 6.40787L13.4797 6.39455V6.16133C13.4514 4.72872 12.7327 3.97709 11.4426 3.86515L11.4432 4.37822C11.4432 4.66475 11.2201 4.89197 10.937 4.89197C10.6474 4.89263 10.4296 4.66608 10.4296 4.37956L10.4289 3.83983L6.51908 3.84516L6.51974 4.38422C6.51974 4.67141 6.30318 4.89796 6.01357 4.89796C5.72395 4.89863 5.50608 4.67274 5.50608 4.38555L5.50542 3.87248C4.2219 4.00108 3.51168 4.75537 3.51365 6.20064L3.51431 6.40787ZM10.66 9.43636V9.44369C10.6666 9.7502 10.9167 9.98275 11.2201 9.97609C11.5163 9.96876 11.7526 9.71488 11.7461 9.40837C11.7322 9.11518 11.4946 8.87597 11.1991 8.87664C10.8963 8.8833 10.6593 9.12984 10.66 9.43636ZM11.2036 12.4282C10.9008 12.4215 10.6566 12.169 10.656 11.8625C10.6494 11.556 10.8923 11.3021 11.195 11.2948H11.2016C11.511 11.2948 11.7618 11.5473 11.7618 11.8605C11.7624 12.1737 11.5123 12.4275 11.2036 12.4282ZM7.948 9.44702C7.96116 9.75353 8.21194 9.99275 8.51472 9.97942C8.81092 9.96543 9.04722 9.71222 9.03406 9.40571C9.02682 9.10586 8.78328 8.87264 8.48708 8.87331C8.1843 8.88663 7.94734 9.14051 7.948 9.44702ZM8.51737 12.3982C8.21459 12.4115 7.96447 12.1723 7.95065 11.8658C7.95065 11.5593 8.18695 11.3061 8.48973 11.2921C8.78593 11.2914 9.03013 11.5246 9.03671 11.8238C9.05053 12.131 8.81357 12.3842 8.51737 12.3982ZM5.23616 9.47034C5.24933 9.77685 5.50011 10.0167 5.80289 10.0027C6.09909 9.98941 6.33539 9.73554 6.32157 9.42903C6.31498 9.12918 6.07144 8.89596 5.77459 8.89663C5.47181 8.90995 5.23551 9.16383 5.23616 9.47034ZM5.80554 12.4015C5.50276 12.4155 5.25263 12.1756 5.23881 11.8691C5.23815 11.5626 5.47511 11.3087 5.77789 11.2954C6.07409 11.2948 6.31829 11.528 6.32487 11.8278C6.33869 12.1343 6.10239 12.3882 5.80554 12.4015Z"
      />
    </SvgIcon>
  )
}

export const GenderIcon = (props) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 32 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M31.1716 7.88203C30.8887 7.95487 30.5885 7.91244 30.3369 7.76405C30.0853 7.61566 29.9029 7.37346 29.8297 7.09066L29.4632 5.66609L27.1806 9.59372C28.5049 10.6225 29.5043 12.0115 30.059 13.5941C30.6136 15.1767 30.6998 16.8857 30.3074 18.5161C29.9149 20.1465 29.0605 21.6291 27.8465 22.786C26.6324 23.9428 25.1104 24.7249 23.463 25.0384C21.8156 25.3519 20.1128 25.1834 18.5587 24.5532C17.0046 23.923 15.6654 22.8579 14.7016 21.4856C13.7378 20.1132 13.1904 18.492 13.125 16.8163C13.0596 15.1406 13.4791 13.4816 14.333 12.0384C15.1144 10.7165 15.4039 9.16112 15.1503 7.64664C14.8967 6.13217 14.1163 4.75592 12.9469 3.76072C11.7775 2.76552 10.2942 2.21533 8.75865 2.20721C7.22311 2.19909 5.73404 2.73357 4.55417 3.71634C3.37429 4.69912 2.57944 6.06704 2.30984 7.57875C2.04025 9.09046 2.31323 10.6488 3.08064 11.9789C3.84804 13.3089 5.06055 14.3252 6.50423 14.8484C7.94792 15.3716 9.53 15.3681 10.9713 14.8385C11.2458 14.7378 11.549 14.7504 11.8143 14.8733C12.0795 14.9962 12.2851 15.2195 12.3857 15.494C12.4864 15.7685 12.4738 16.0717 12.3509 16.3369C12.228 16.6022 12.0047 16.8077 11.7302 16.9084C11.1145 17.1319 10.4756 17.2855 9.82562 17.3663V20.0347H11.8509C12.1432 20.0347 12.4235 20.1508 12.6302 20.3575C12.8369 20.5642 12.9531 20.8446 12.9531 21.1369C12.9531 21.4292 12.8369 21.7096 12.6302 21.9163C12.4235 22.123 12.1432 22.2391 11.8509 22.2391H9.82617V24.3228C9.82617 24.6151 9.71005 24.8954 9.50335 25.1021C9.29665 25.3088 9.01631 25.4249 8.72399 25.4249C8.43167 25.4249 8.15133 25.3088 7.94463 25.1021C7.73793 24.8954 7.62181 24.6151 7.62181 24.3228V22.2391H5.59654C5.30423 22.2391 5.02388 22.123 4.81718 21.9163C4.61048 21.7096 4.49436 21.4292 4.49436 21.1369C4.49436 20.8446 4.61048 20.5642 4.81718 20.3575C5.02388 20.1508 5.30423 20.0347 5.59654 20.0347H7.62181V17.3746C5.76016 17.1378 4.02451 16.307 2.67262 15.0054C1.32073 13.7038 0.424703 12.0008 0.117595 10.1495C-0.189514 8.29815 0.108681 6.39713 0.967896 4.72874C1.82711 3.06035 3.20152 1.71357 4.88701 0.888408C6.57251 0.0632469 8.47919 -0.196286 10.3239 0.148349C12.1686 0.492985 13.853 1.42341 15.1269 2.80145C16.4008 4.17949 17.1962 5.93165 17.3951 7.79772C17.594 9.66379 17.1858 11.5442 16.231 13.1598C15.4544 14.4751 15.1645 16.0215 15.412 17.5287C15.6595 19.036 16.4287 20.4084 17.5851 21.4063C18.7416 22.4041 20.2119 22.964 21.7391 22.9881C23.2664 23.0122 24.7536 22.4991 25.941 21.5382C27.1284 20.5774 27.9405 19.2299 28.2355 17.7312C28.5304 16.2325 28.2895 14.6778 27.5549 13.3386C26.8202 11.9995 25.6384 10.961 24.2159 10.4045C22.7934 9.84805 21.2206 9.80899 19.7723 10.2942C19.635 10.34 19.49 10.3584 19.3456 10.3483C19.2012 10.3381 19.0602 10.2997 18.9307 10.235C18.8012 10.1704 18.6857 10.0809 18.5908 9.9716C18.4958 9.86232 18.4233 9.73542 18.3775 9.59813C18.3316 9.46084 18.3132 9.31586 18.3233 9.17147C18.3335 9.02707 18.372 8.88609 18.4366 8.75657C18.5012 8.62705 18.5907 8.51153 18.7 8.4166C18.8093 8.32167 18.9362 8.2492 19.0735 8.20332C21.1052 7.52612 23.3151 7.62068 25.2815 8.46894L27.5857 4.50494L26.1065 4.88519C25.9663 4.92138 25.8204 4.9296 25.6771 4.90938C25.5337 4.88917 25.3957 4.84091 25.271 4.76738C25.1463 4.69384 25.0373 4.59646 24.9502 4.4808C24.8631 4.36514 24.7997 4.23345 24.7635 4.09327C24.7273 3.95309 24.7191 3.80715 24.7393 3.6638C24.7595 3.52044 24.8078 3.38247 24.8813 3.25776C24.9549 3.13305 25.0522 3.02404 25.1679 2.93696C25.2836 2.84989 25.4153 2.78645 25.5554 2.75026L29.5872 1.71752C29.6131 1.7109 29.6385 1.71035 29.6644 1.70594C29.7078 1.69638 29.7518 1.68957 29.7961 1.68555C29.8386 1.68453 29.8811 1.68601 29.9234 1.68996C29.952 1.68996 29.9785 1.68996 30.0094 1.69437C30.0589 1.702 30.1079 1.71304 30.156 1.72744C30.1769 1.7335 30.1978 1.73625 30.2182 1.74342C30.2831 1.76558 30.3457 1.794 30.405 1.82829L30.4155 1.83269C30.4798 1.87004 30.5402 1.9138 30.5957 1.9633C30.6487 2.0106 30.6969 2.06303 30.7396 2.11981C30.7594 2.14626 30.7737 2.17492 30.7914 2.20358C30.8132 2.23559 30.8335 2.2687 30.852 2.30278C30.8833 2.36763 30.9082 2.43536 30.9264 2.50503V2.50999L31.9652 6.53957C32.0013 6.67982 32.0094 6.82582 31.9891 6.96922C31.9687 7.11261 31.9203 7.25059 31.8466 7.37527C31.7729 7.49994 31.6754 7.60887 31.5596 7.69582C31.4437 7.78278 31.3119 7.84605 31.1716 7.88203Z" />
    </SvgIcon>
  )
}

export const WorkIcon = (props) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.70435 1.51898C8.03402 1.51898 7.46373 1.9848 7.30365 2.61265H12.6863C12.5263 1.9848 11.956 1.51898 11.2856 1.51898H8.70435ZM14.2071 2.61264H16.1881C18.2891 2.61264 20 4.34428 20 6.47085C20 6.47085 19.94 7.3711 19.92 8.62477C19.918 8.72401 19.8699 8.82122 19.7909 8.87996C19.3097 9.2354 18.8694 9.52907 18.8294 9.54932C17.1686 10.6632 15.2386 11.447 13.1826 11.8369C13.0485 11.8632 12.9165 11.7934 12.8484 11.6739C12.2721 10.6754 11.1956 10.0253 9.995 10.0253C8.8024 10.0253 7.71586 10.6683 7.12256 11.6678C7.05353 11.7853 6.92346 11.8531 6.7904 11.8278C4.75138 11.4369 2.82141 10.6541 1.17059 9.55945L0.210105 8.89109C0.130065 8.84046 0.08004 8.74932 0.08004 8.64806C0.050025 8.13161 0 6.47085 0 6.47085C0 4.34428 1.71086 2.61264 3.81191 2.61264H5.78289C5.97299 1.1443 7.2036 0 8.70435 0H11.2856C12.7864 0 14.017 1.1443 14.2071 2.61264ZM19.6598 10.8152L19.6198 10.8355C17.5988 12.1924 15.1676 13.0937 12.6163 13.4684C12.2561 13.519 11.8959 13.2861 11.7959 12.9216C11.5758 12.0912 10.8654 11.5443 10.015 11.5443H10.005H9.98499C9.13457 11.5443 8.42421 12.0912 8.2041 12.9216C8.10405 13.2861 7.74387 13.519 7.38369 13.4684C4.83242 13.0937 2.4012 12.1924 0.38019 10.8355C0.370185 10.8254 0.270135 10.7646 0.190095 10.8152C0.10005 10.8659 0.10005 10.9874 0.10005 10.9874L0.170085 16.1519C0.170085 18.2785 1.87094 20 3.97199 20H16.018C18.1191 20 19.8199 18.2785 19.8199 16.1519L19.9 10.9874C19.9 10.9874 19.9 10.8659 19.8099 10.8152C19.7599 10.7849 19.6999 10.795 19.6598 10.8152ZM10.7454 15.0583C10.7454 15.4836 10.4152 15.8177 9.995 15.8177C9.58479 15.8177 9.24462 15.4836 9.24462 15.0583V13.7519C9.24462 13.3367 9.58479 12.9924 9.995 12.9924C10.4152 12.9924 10.7454 13.3367 10.7454 13.7519V15.0583Z"
      />
    </SvgIcon>
  )
}

export const LocationIcon = (props) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 23 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.166504 11.7573C0.166504 5.62418 5.29168 0.666992 11.4911 0.666992C17.708 0.666992 22.8332 5.62418 22.8332 11.7573C22.8332 14.8479 21.7092 17.7172 19.8592 20.1491C17.8182 22.8317 15.3027 25.1689 12.4712 27.0036C11.8232 27.4275 11.2383 27.4595 10.5271 27.0036C7.67948 25.1689 5.16395 22.8317 3.1405 20.1491C1.28915 17.7172 0.166504 14.8479 0.166504 11.7573ZM7.75884 12.1027C7.75884 14.1573 9.43542 15.7732 11.4911 15.7732C13.5482 15.7732 15.2409 14.1573 15.2409 12.1027C15.2409 10.0641 13.5482 8.36944 11.4911 8.36944C9.43542 8.36944 7.75884 10.0641 7.75884 12.1027Z"
      />
    </SvgIcon>
  )
}

export const EditMatIcon = (props) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.3764 17.0279L15.1628 5.66544C15.6403 5.0527 15.8101 4.3443 15.6509 3.62299C15.513 2.96726 15.1097 2.34377 14.5049 1.87078L13.0299 0.699064C11.7459 -0.322161 10.1541 -0.214663 9.24152 0.957057L8.25465 2.23735C8.12731 2.39752 8.15914 2.63401 8.31832 2.76301C8.31832 2.76301 10.812 4.76246 10.8651 4.80546C11.0349 4.96671 11.1622 5.1817 11.1941 5.43969C11.2471 5.94493 10.8969 6.41792 10.377 6.48242C10.1329 6.51467 9.89944 6.43942 9.72966 6.29967L7.1086 4.21422C6.98126 4.11855 6.79025 4.13898 6.68413 4.26797L0.455138 12.3303C0.0518984 12.8355 -0.086052 13.4912 0.0518984 14.1255L0.847767 17.5761C0.890213 17.7589 1.04939 17.8879 1.24039 17.8879L4.74222 17.8449C5.37891 17.8341 5.97316 17.5439 6.3764 17.0279ZM11.2797 15.9533H16.9898C17.5469 15.9533 18 16.4123 18 16.9766C18 17.5421 17.5469 18 16.9898 18H11.2797C10.7226 18 10.2695 17.5421 10.2695 16.9766C10.2695 16.4123 10.7226 15.9533 11.2797 15.9533Z"
      />
    </SvgIcon>
  )
}

export const ShareMatIcon = (props) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M19.4354 0.581983C18.9352 0.0685981 18.1949 -0.122663 17.5046 0.0786645L1.408 4.75952C0.679698 4.96186 0.163487 5.54269 0.0244302 6.28055C-0.117628 7.0315 0.378575 7.98479 1.02684 8.38342L6.0599 11.4768C6.57611 11.7939 7.24238 11.7144 7.66956 11.2835L13.4329 5.4843C13.723 5.18231 14.2032 5.18231 14.4934 5.4843C14.7835 5.77623 14.7835 6.24935 14.4934 6.55134L8.71999 12.3516C8.29181 12.7814 8.21178 13.4508 8.52691 13.9702L11.6022 19.0538C11.9623 19.6577 12.5826 20 13.2628 20C13.3429 20 13.4329 20 13.513 19.9899C14.2933 19.8893 14.9135 19.3558 15.1436 18.6008L19.9156 2.52479C20.1257 1.84028 19.9356 1.09537 19.4354 0.581983Z" />
    </SvgIcon>
  )
}

export const DocumentMatIcon = (props) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 24 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.41333 0.666504H17.588C21.7067 0.666504 24 3.03984 24 7.1065V20.8798C24 25.0132 21.7067 27.3332 17.588 27.3332H6.41333C2.36 27.3332 0 25.0132 0 20.8798V7.1065C0 3.03984 2.36 0.666504 6.41333 0.666504ZM6.7734 6.87971V6.86637H10.7587C11.3334 6.86637 11.8001 7.33304 11.8001 7.90504C11.8001 8.49304 11.3334 8.95971 10.7587 8.95971H6.7734C6.19873 8.95971 5.7334 8.49304 5.7334 7.91971C5.7334 7.34637 6.19873 6.87971 6.7734 6.87971ZM6.7734 14.9861H17.2267C17.8001 14.9861 18.2667 14.5195 18.2667 13.9461C18.2667 13.3728 17.8001 12.9048 17.2267 12.9048H6.7734C6.19873 12.9048 5.7334 13.3728 5.7334 13.9461C5.7334 14.5195 6.19873 14.9861 6.7734 14.9861ZM6.77328 21.0796H17.2266C17.7586 21.0263 18.1599 20.5716 18.1599 20.0396C18.1599 19.493 17.7586 19.0396 17.2266 18.9863H6.77328C6.37328 18.9463 5.98662 19.133 5.77328 19.4796C5.55995 19.813 5.55995 20.253 5.77328 20.5996C5.98662 20.933 6.37328 21.133 6.77328 21.0796Z"
      />
    </SvgIcon>
  )
}

export const DownloadMatIcon = (props) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 28 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9733 6.72086V1.3755C12.9733 0.807135 13.4266 0.333496 14 0.333496C14.5133 0.333496 14.9482 0.731485 15.0171 1.2356L15.0266 1.3755V6.72086L21.3998 6.72126C24.5732 6.72126 27.1803 9.31987 27.3267 12.5607L27.3332 12.8483V19.5673C27.3332 22.8309 24.8167 25.5098 21.6905 25.6602L21.4132 25.6668H6.5865C3.41317 25.6668 0.818624 23.0812 0.672954 19.8285L0.666504 19.5398L0.666504 12.8345C0.666504 9.57097 3.17038 6.87911 6.29583 6.72796L6.57317 6.72126H12.9732V15.2578L10.8398 13.0548C10.4398 12.6418 9.7865 12.6418 9.3865 13.0548C9.1865 13.2613 9.09317 13.5367 9.09317 13.8121C9.09317 14.0214 9.1529 14.2395 9.2792 14.4241L9.3865 14.5556L13.2665 18.576C13.4532 18.7825 13.7198 18.8927 13.9998 18.8927C14.2221 18.8927 14.4443 18.8162 14.6202 18.6712L14.7198 18.576L18.5998 14.5556C18.9998 14.1425 18.9998 13.4679 18.5998 13.0548C18.2362 12.6793 17.6632 12.6452 17.2615 12.9524L17.1465 13.0548L15.0265 15.2578V6.72126L12.9733 6.72086Z"
        fill="#449A68"
      />
    </SvgIcon>
  )
}

export const PhoneIcon = (props) => (
  <SvgIcon
    {...props}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16.1666 12.3797C15.4949 12.2352 14.9635 12.5471 14.493 12.8194C14.0111 13.1001 13.0949 13.8434 12.5697 13.6531C9.88084 12.546 7.35189 10.1925 6.25714 7.49286C6.0642 6.95647 6.804 6.0344 7.08259 5.54686C7.35292 5.07492 7.65833 4.53852 7.51904 3.86178C7.39316 3.25366 5.76497 1.18188 5.18923 0.615332C4.80952 0.241101 4.42053 0.0352739 4.02123 0.00200893C2.51995 -0.0624419 0.843272 1.94073 0.549208 2.41996C-0.187499 3.44181 -0.183372 4.80152 0.56159 6.45021C2.35693 10.8786 9.14723 17.5618 13.5922 19.4246C14.4125 19.8082 15.1626 20.0005 15.8364 20.0005C16.4957 20.0005 17.0828 19.8165 17.5874 19.4516C17.9681 19.2323 20.0534 17.4724 19.9987 15.9307C19.9657 15.5378 19.7604 15.1448 19.391 14.7644C18.8286 14.1833 16.7702 12.5065 16.1666 12.3797Z" />
  </SvgIcon>
)

export const MailIcon = (props) => (
  <SvgIcon
    {...props}
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.9394 0C16.2804 0 17.5704 0.53 18.5194 1.481C19.4694 2.43 20.0004 3.71 20.0004 5.05V12.95C20.0004 15.74 17.7304 18 14.9394 18H5.0604C2.2694 18 0.000396729 15.74 0.000396729 12.95V5.05C0.000396729 2.26 2.2594 0 5.0604 0H14.9394ZM16.5304 6.54L16.6104 6.46C16.8494 6.17 16.8494 5.75 16.5994 5.46C16.4604 5.311 16.2694 5.22 16.0704 5.2C15.8604 5.189 15.6604 5.26 15.5094 5.4L11.0004 9C10.4204 9.481 9.5894 9.481 9.0004 9L4.5004 5.4C4.1894 5.17 3.7594 5.2 3.5004 5.47C3.2304 5.74 3.2004 6.17 3.4294 6.47L3.5604 6.6L8.1104 10.15C8.6704 10.59 9.3494 10.83 10.0604 10.83C10.7694 10.83 11.4604 10.59 12.0194 10.15L16.5304 6.54Z"
    />
  </SvgIcon>
)

export const WorkMatIcon = (props) => (
  <SvgIcon
    {...props}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.70435 1.51898C8.03402 1.51898 7.46373 1.9848 7.30365 2.61265H12.6863C12.5263 1.9848 11.956 1.51898 11.2856 1.51898H8.70435ZM14.2071 2.61264H16.1881C18.2891 2.61264 20 4.34428 20 6.47085C20 6.47085 19.94 7.3711 19.92 8.62477C19.918 8.72401 19.8699 8.82122 19.7909 8.87996C19.3097 9.2354 18.8694 9.52907 18.8294 9.54932C17.1686 10.6632 15.2386 11.447 13.1826 11.8369C13.0485 11.8632 12.9165 11.7934 12.8484 11.6739C12.2721 10.6754 11.1956 10.0253 9.995 10.0253C8.8024 10.0253 7.71586 10.6683 7.12256 11.6678C7.05353 11.7853 6.92346 11.8531 6.7904 11.8278C4.75138 11.4369 2.82141 10.6541 1.17059 9.55945L0.210105 8.89109C0.130065 8.84046 0.08004 8.74932 0.08004 8.64806C0.050025 8.13161 0 6.47085 0 6.47085C0 4.34428 1.71086 2.61264 3.81191 2.61264H5.78289C5.97299 1.1443 7.2036 0 8.70435 0H11.2856C12.7864 0 14.017 1.1443 14.2071 2.61264ZM19.6598 10.8152L19.6198 10.8355C17.5988 12.1924 15.1676 13.0937 12.6163 13.4684C12.2561 13.519 11.8959 13.2861 11.7959 12.9216C11.5758 12.0912 10.8654 11.5443 10.015 11.5443H10.005H9.98499C9.13457 11.5443 8.42421 12.0912 8.2041 12.9216C8.10405 13.2861 7.74387 13.519 7.38369 13.4684C4.83242 13.0937 2.4012 12.1924 0.38019 10.8355C0.370185 10.8254 0.270135 10.7646 0.190095 10.8152C0.10005 10.8659 0.10005 10.9874 0.10005 10.9874L0.170085 16.1519C0.170085 18.2785 1.87094 20 3.97199 20H16.018C18.1191 20 19.8199 18.2785 19.8199 16.1519L19.9 10.9874C19.9 10.9874 19.9 10.8659 19.8099 10.8152C19.7599 10.7849 19.6999 10.795 19.6598 10.8152ZM10.7454 15.0583C10.7454 15.4836 10.4152 15.8177 9.995 15.8177C9.58479 15.8177 9.24462 15.4836 9.24462 15.0583V13.7519C9.24462 13.3367 9.58479 12.9924 9.995 12.9924C10.4152 12.9924 10.7454 13.3367 10.7454 13.7519V15.0583Z"
    />
  </SvgIcon>
)

export const LockIcon = (props) => (
  <SvgIcon
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.5227 7.39601V8.92935C19.2451 9.46696 20.5 11.0261 20.5 12.8884V17.8253C20.5 20.1308 18.5886 22 16.2322 22H7.7688C5.41136 22 3.5 20.1308 3.5 17.8253V12.8884C3.5 11.0261 4.75595 9.46696 6.47729 8.92935V7.39601C6.48745 4.41479 8.95667 2 11.9848 2C15.0535 2 17.5227 4.41479 17.5227 7.39601ZM12.0051 3.73904C14.0678 3.73904 15.7445 5.37871 15.7445 7.39601V8.7137H8.25553V7.37613C8.26569 5.36878 9.94232 3.73904 12.0051 3.73904ZM12.8891 16.4549C12.8891 16.9419 12.4928 17.3294 11.9949 17.3294C11.5072 17.3294 11.1109 16.9419 11.1109 16.4549V14.2488C11.1109 13.7718 11.5072 13.3843 11.9949 13.3843C12.4928 13.3843 12.8891 13.7718 12.8891 14.2488V16.4549Z"
    />
  </SvgIcon>
)

export const NotificationIcon = (props) => (
  <SvgIcon
    {...props}
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.50083 12.7871V12.5681C1.53295 11.9202 1.7406 11.2925 2.10236 10.7496C2.7045 10.0975 3.1167 9.29831 3.29571 8.43598C3.29571 7.7695 3.29571 7.0935 3.35393 6.42703C3.65469 3.21842 6.82728 1 9.96106 1H10.0387C13.1725 1 16.345 3.21842 16.6555 6.42703C16.7137 7.0935 16.6555 7.7695 16.704 8.43598C16.8854 9.3003 17.2972 10.1019 17.8974 10.7591C18.2618 11.2972 18.4698 11.9227 18.4989 12.5681V12.7776C18.5206 13.648 18.2208 14.4968 17.6548 15.1674C16.907 15.9515 15.8921 16.4393 14.8024 16.5384C11.607 16.8812 8.38303 16.8812 5.18762 16.5384C4.09914 16.435 3.08576 15.9479 2.33521 15.1674C1.778 14.4963 1.48224 13.6526 1.50083 12.7871Z"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.55493 19.8516C8.05421 20.4782 8.78739 20.8838 9.59222 20.9785C10.3971 21.0732 11.2072 20.8493 11.8433 20.3562C12.0389 20.2103 12.2149 20.0408 12.3672 19.8516"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </SvgIcon>
)

export const DeleteMatIcon = (props) => (
  <SvgIcon
    {...props}
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.2871 3.24297C17.6761 3.24297 18 3.56596 18 3.97696V4.35696C18 4.75795 17.6761 5.09095 17.2871 5.09095H0.713853C0.32386 5.09095 0 4.75795 0 4.35696V3.97696C0 3.56596 0.32386 3.24297 0.713853 3.24297H3.62957C4.22185 3.24297 4.7373 2.82197 4.87054 2.22798L5.02323 1.54598C5.26054 0.616994 6.0415 0 6.93527 0H11.0647C11.9488 0 12.7385 0.616994 12.967 1.49699L13.1304 2.22698C13.2627 2.82197 13.7781 3.24297 14.3714 3.24297H17.2871ZM15.8058 17.134C16.1102 14.2971 16.6432 7.55712 16.6432 7.48913C16.6626 7.28313 16.5955 7.08813 16.4623 6.93113C16.3193 6.78413 16.1384 6.69713 15.9391 6.69713H2.06852C1.86818 6.69713 1.67756 6.78413 1.54529 6.93113C1.41108 7.08813 1.34494 7.28313 1.35467 7.48913C1.35646 7.50162 1.37558 7.73903 1.40755 8.13594C1.54958 9.89917 1.94517 14.8102 2.20079 17.134C2.38168 18.846 3.50498 19.922 5.13206 19.961C6.38763 19.99 7.68112 20 9.00379 20C10.2496 20 11.5149 19.99 12.8094 19.961C14.4929 19.932 15.6152 18.875 15.8058 17.134Z"
    />
  </SvgIcon>
)

export const SearchIcon = (props) => (
  <SvgIcon
    {...props}
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="10.9886"
      cy="10.9886"
      r="8.98856"
      stroke="#1D1D1D"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.2402 17.707L20.7643 21.2219"
      stroke="#1D1D1D"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </SvgIcon>
)

export const SearchDarkIcon = (props) => (
  <SvgIcon
    {...props}
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      fill="#1D1D1D"
      cx="10.9886"
      cy="10.9886"
      r="8.98856"
      stroke="#fff"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.2402 17.707L20.7643 21.2219"
      stroke="#fff"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </SvgIcon>
)

export const HomeMatIcon = (props) => (
  <SvgIcon
    {...props}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.13478 18.7733V15.7156C7.13478 14.9351 7.77217 14.3023 8.55844 14.3023H11.4326C11.8102 14.3023 12.1723 14.4512 12.4393 14.7163C12.7063 14.9813 12.8563 15.3408 12.8563 15.7156V18.7733C12.8539 19.0978 12.9821 19.4099 13.2124 19.6402C13.4427 19.8705 13.7561 20 14.0829 20H16.0438C16.9596 20.0023 17.8388 19.6428 18.4872 19.0008C19.1356 18.3588 19.5 17.487 19.5 16.5778V7.86686C19.5 7.13246 19.1721 6.43584 18.6046 5.96467L11.934 0.675869C10.7737 -0.251438 9.11111 -0.221498 7.98539 0.746979L1.46701 5.96467C0.872741 6.42195 0.517552 7.12064 0.5 7.86686V16.5689C0.5 18.4639 2.04738 20 3.95617 20H5.87229C6.55123 20 7.103 19.4562 7.10792 18.7822L7.13478 18.7733Z" />
  </SvgIcon>
)

export const CloseMatIcon = (props) => (
  <SvgIcon
    {...props}
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.6668 16.0002C29.6668 23.2719 23.7719 29.1668 16.5002 29.1668C9.22841 29.1668 3.3335 23.2719 3.3335 16.0002C3.3335 8.72841 9.22841 2.8335 16.5002 2.8335C23.7719 2.8335 29.6668 8.72841 29.6668 16.0002Z"
      stroke={"#449A68"}
      fill="transparent"
      stroke-width="3"
    />
    <path
      d="M19.9491 21.3081L16.7722 18.1312L13.6029 21.3005C13.0877 21.8156 12.2595 21.8161 11.7449 21.3015C11.2303 20.7869 11.2308 19.9587 11.7459 19.4435L14.9152 16.2742L11.7495 13.1085C11.2461 12.5827 11.2465 11.7544 11.7617 11.2393C12.0092 10.9918 12.3439 10.8584 12.6909 10.847C13.0379 10.858 13.3736 10.9921 13.6197 11.2382L16.7854 14.404L19.9435 11.2459C20.4587 10.7308 21.287 10.7303 21.8015 11.2449C22.3161 11.7595 22.3156 12.5877 21.8005 13.1029L18.6424 16.261L21.8194 19.4379C22.3339 19.9525 22.3335 20.7808 21.8183 21.2959C21.3032 21.8111 20.4749 21.8115 19.9491 21.3081Z"
      fill={"#449A68"}
    />
  </SvgIcon>
)
